import {
  CDCM_IFRAME_LAUNCH_MODES,
  IFRAME_KEYS,
} from "../../pages/LandingPage/constants";
import { LaunchContext } from "../../types";
import { getPaymentsLaunchContext } from "./getPaymentsLaunchContext";

export const getLaunchContext = (): LaunchContext | undefined => {
  const params = new URLSearchParams(window.location.search);

  const launchModeParam = params
    .get(IFRAME_KEYS.PARAMS.LAUNCH_MODE)
    ?.trim()
    .toLowerCase();

  const launchMode = CDCM_IFRAME_LAUNCH_MODES.find(
    (mode) => mode.toLowerCase() === launchModeParam,
  );

  if (!launchMode) {
    return undefined;
  }

  if (launchMode === "payments") {
    const payments = getPaymentsLaunchContext();

    return payments
      ? {
          launchMode,
          payments,
        }
      : undefined;
  }

  return {
    launchMode,
  };
};
